export enum MenuActions {
  Renew = 'renew',
}
